import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../lib/GlobalVar';
import { ConsultaConexoes, SalvaConexao, RemoveConexao, ValidaConexao } from '../../lib/api';
import Swal from 'sweetalert2';
import Icon from '../Icon';

const VAZIO = { driver: 'pg', prefixo: '', host: '', porta: '5432', db: '', user: '', senha: '', conn: '' };

export default function TIBancos() {
    const { user } = useContext(GlobalContext);
    const [conexoes, setConexoes] = useState([]);
    const [modal, setModal] = useState(null);
    const [testando, setTestando] = useState({}); // {prefixo: true} enquanto roda

    useEffect(() => { reload(); }, []);

    async function reload() {
        const resp = await ConsultaConexoes({});
        if (resp.Error) return setConexoes([]);
        setConexoes(Array.isArray(resp) ? resp : (resp.conexoes || []));
    }

    async function salvar(form) {
        if (!form.prefixo) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Informe o prefixo (ex: DEMO).' });
        if (form.driver === 'pg' && (!form.host || !form.user)) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Para Postgres preencha host e usuário.' });
        if (form.driver === 'oracledb' && (!form.conn || !form.user)) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Para Oracle preencha string de conexão e usuário.' });

        const payload = {
            solicitante: user?.email,
            driver: form.driver,
            prefixo: (() => { const u = form.prefixo.toUpperCase().replace(/[^A-Z0-9_]/g, '_'); return u.startsWith('PG_') || u.startsWith('ORACLE_') ? u : (form.driver === 'pg' ? 'PG_' + u : 'ORACLE_' + u); })(),
            host: form.host, porta: form.porta, db: form.db,
            user: form.user, senha: form.senha, conn: form.conn
        };
        const resp = await SalvaConexao(payload);
        if (resp.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        Swal.fire({ icon: 'success', title: 'Conexão salva no .env', text: 'Reinicie o backend (pm2 reload) para aplicar.', timer: 2200, showConfirmButton: false });
        setModal(null);
        reload();
    }

    async function testarConexao(c) {
        setTestando(t => ({ ...t, [c.prefixo]: true }));
        const r = await ValidaConexao({ solicitante: user?.email, prefixo: c.prefixo, driver: c.driver });
        setTestando(t => { const n = { ...t }; delete n[c.prefixo]; return n; });
        if (r.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: r.Error });
        if (r.ok) {
            Swal.fire({ icon: 'success', title: 'Conexão OK', text: `${r.info || ''} · ${r.latency_ms}ms`, timer: 1600, showConfirmButton: false });
        } else {
            Swal.fire({ icon: 'error', title: 'Conexão falhou', text: r.err || 'Erro desconhecido', html: r.err ? `<pre style="text-align:left;white-space:pre-wrap;font-size:11px;">${r.err}</pre>` : undefined });
        }
        reload();
    }

    async function excluirConexao(c) {
        const ok = await Swal.fire({
            icon: 'warning',
            title: `Excluir conexão ${c.prefixo}?`,
            text: 'As variáveis do .env serão removidas. Operação irreversível.',
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            confirmButtonColor: '#c0392b'
        });
        if (!ok.isConfirmed) return;
        const r = await RemoveConexao({ solicitante: user?.email, prefixo: c.prefixo });
        if (r.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: r.Error });
        Swal.fire({ icon: 'success', title: 'Conexão removida', timer: 1100, showConfirmButton: false });
        reload();
    }

    return (
        <div className="page">
            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num ti">TI</span> Conexões de Banco</div>
                    <h1 className="page-title">Conexões de Banco</h1>
                    <p className="page-sub">Pools <span className="mono">pg</span> e <span className="mono">oracledb</span> instanciados a partir de prefixos no <span className="mono">.env</span>. Adicione uma conexão e o backend reconhece no próximo restart.</p>
                </div>
                <button className="btn" onClick={() => setModal({ ...VAZIO })}>
                    <Icon name="plus" size={12}/> Nova conexão
                </button>
            </div>

            <div className="banks-grid">
                {conexoes.map(c => {
                    const v = c.validacao;
                    const ehTestando = !!testando[c.prefixo];
                    return (
                        <div className="bank-card" key={c.id || c.prefixo} style={{ position:'relative', display:'flex', flexDirection:'column', gap:10, padding:'18px 20px', minHeight:200 }}>
                            <span className="bank-badge">{c.driver === 'oracledb' ? 'OR' : 'PG'}</span>

                            {/* TOPO: icone + nome + status */}
                            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                                <div className="bank-icon" style={{ flexShrink:0 }}>
                                    <span className="bank-icon-lbl">{c.driver === 'oracledb' ? 'OR' : 'PG'}</span>
                                </div>
                                <div style={{ flex:1, minWidth:0 }}>
                                    <div className="bank-name" style={{ marginBottom:4, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }} title={c.prefixo}>
                                        {c.prefixo}
                                    </div>
                                    {v && v.ok && (
                                        <span title={`Validado ${v.ts ? new Date(v.ts).toLocaleString('pt-BR') : ''} · ${v.latency_ms||'?'}ms`}
                                              style={{ fontSize:10, color:'#27ae60', border:'1px solid #27ae60', padding:'1px 7px', letterSpacing:'.08em', display:'inline-block' }}>
                                            ✓ OK
                                        </span>
                                    )}
                                    {v && !v.ok && (
                                        <span title={v.err || 'falha'} style={{ fontSize:10, color:'#c0392b', border:'1px solid #c0392b', padding:'1px 7px', letterSpacing:'.08em', display:'inline-block' }}>
                                            ✗ FALHOU
                                        </span>
                                    )}
                                    {!v && (
                                        <span style={{ fontSize:10, color:'var(--ink-mute)', border:'1px solid var(--line)', padding:'1px 7px', letterSpacing:'.08em', display:'inline-block' }}>
                                            ◦ NÃO TESTADO
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* MEIO: host/conexao */}
                            <div className="bank-host mono" style={{ fontSize:11.5, color:'var(--ink-mute)', wordBreak:'break-all' }}>
                                {c.driver === 'pg'
                                    ? `${c.host}:${c.porta} / ${c.db || '—'}`
                                    : c.conn || '—'}
                            </div>

                            {/* INFO: usuario + senha mascarada */}
                            <div style={{ display:'flex', alignItems:'center', gap:10, fontSize:11, flexWrap:'wrap' }}>
                                <span className="chip" style={{ fontSize:10 }}>SENHA <span className="mono">{c.senha_mask || '—'}</span></span>
                                {c.user && <span className="muted mono" style={{ fontSize:11 }}>{c.user}</span>}
                            </div>

                            {/* Ultimo teste */}
                            {v && v.ts && (
                                <div className="muted" style={{ fontSize:10.5, letterSpacing:'.02em' }}>
                                    Último teste: {new Date(v.ts).toLocaleString('pt-BR', { timeZone:'America/Sao_Paulo' })} {v.ok ? `· ${v.latency_ms}ms` : ''}
                                </div>
                            )}

                            {/* RODAPE: acoes alinhadas em uma linha so */}
                            <div style={{ marginTop:'auto', paddingTop:10, borderTop:'1px dashed var(--line)', display:'grid', gridTemplateColumns:'1fr 1fr 44px', gap:6, alignItems:'stretch' }}>
                                <button className="btn ghost sm" onClick={() => testarConexao(c)} disabled={ehTestando} style={{ width:'100%' }}>
                                    {ehTestando ? '…' : 'Testar'}
                                </button>
                                <button className="btn ghost sm" onClick={() => setModal({ ...VAZIO, ...c })} style={{ width:'100%' }}>Editar</button>
                                <button
                                    className="btn ghost sm"
                                    onClick={() => excluirConexao(c)}
                                    title="Excluir conexão"
                                    style={{ color:'#c0392b', padding:0, width:'100%' }}
                                    aria-label="Excluir"
                                >
                                    <Icon name="trash" size={12}/>
                                </button>
                            </div>
                        </div>
                    );
                })}
                {conexoes.length === 0 && <div className="empty" style={{ gridColumn: '1 / -1' }}>Nenhuma conexão cadastrada.</div>}
            </div>

            <div className="divider"/>

            <div className="card flat">
                <div className="eyebrow"><span className="num">i</span> .env do backend</div>
                <p className="muted mono" style={{ marginTop: 8, fontSize: 12 }}>
                    /tibabita_scripts/Claude-code/CentralBabita-prod/backend/.env
                </p>
                <p className="muted" style={{ marginTop: 6, fontSize: 12 }}>
                    Cada conexão vira um conjunto de variáveis <span className="mono">PREFIXO_HOST</span>, <span className="mono">PREFIXO_PORT</span>, etc.
                </p>
            </div>

            {modal && <BancoModal form={modal} setForm={setModal} onClose={() => setModal(null)} onSave={() => salvar(modal)}/>}
        </div>
    );
}

function BancoModal({ form, setForm, onClose, onSave }) {
    function up(k, v) { setForm({ ...form, [k]: v }); }
    return (
        <div className="modal-mask" onClick={onClose}>
            <div className="modal" onClick={e => e.stopPropagation()}>
                <div className="modal-head">
                    <div className="eyebrow">Conexão de banco</div>
                    <button className="icon-btn" onClick={onClose}><Icon name="x" size={14}/></button>
                </div>
                <div className="modal-body">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 }}>
                        <div className="field"><label>Driver</label><select className="select" value={form.driver} onChange={e => up('driver', e.target.value)}>
                            <option value="pg">Postgres</option>
                            <option value="oracledb">Oracle</option>
                        </select></div>
                        <div className="field"><label>Prefixo (.env)</label><input className="input mono" placeholder="DEMO" value={form.prefixo} onChange={e => up('prefixo', e.target.value)}/></div>
                    </div>
                    {form.driver === 'pg' && (
                        <>
                            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 10 }}>
                                <div className="field"><label>Host</label><input className="input mono" placeholder="127.0.0.1" value={form.host} onChange={e => up('host', e.target.value)}/></div>
                                <div className="field"><label>Porta</label><input className="input mono" value={form.porta} onChange={e => up('porta', e.target.value)}/></div>
                            </div>
                            <div className="field"><label>Database</label><input className="input mono" value={form.db} onChange={e => up('db', e.target.value)}/></div>
                        </>
                    )}
                    {form.driver === 'oracledb' && (
                        <div className="field"><label>Conexão (TNS / EZCONNECT)</label><input className="input mono" placeholder="host:porta/service" value={form.conn} onChange={e => up('conn', e.target.value)}/></div>
                    )}
                    <div className="field"><label>Usuário</label><input className="input" value={form.user} onChange={e => up('user', e.target.value)}/></div>
                    <div className="field"><label>Senha</label><input className="input" type="password" placeholder={form.senha_mask ? '(mantém atual)' : ''} value={form.senha} onChange={e => up('senha', e.target.value)}/></div>
                </div>
                <div className="modal-foot">
                    <button className="btn ghost sm" onClick={onClose}>Cancelar</button>
                    <button className="btn sm" onClick={onSave}>Salvar</button>
                </div>
            </div>
        </div>
    );
}
